import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { bindActionCreators } from 'redux';
import { Field, Form, Formik } from 'formik';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon } from '../../common/custom/icon-library';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import ParentContentCard from '../common/ParentContentCard';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import { isProjectReadOnly } from '../../common/utils/api_utils';
export class RobotsTxt extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  handleRobotsTxtSubmit = (values) => {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.addProjectRobotsTxt({
      projectId,
      version,
      data: values,
    });
  };

  render() {
    const { appSetting } = this.props || {};
    const { projectDetail, addProjectRobotsTxtPending } = appSetting;
    let robotsTxt = '';
    if (!projectDetail) {
      return <div>Loading...</div>;
    }
    const { content, uuid: projectId } = projectDetail;
    robotsTxt = content && content.robotsTxt ? content.robotsTxt : '';
    const isReadOnly = isProjectReadOnly(projectId);

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'robots'} projectDetail={projectDetail} />
        <ParentContentCard title="Create Robots.txt" bgColor="drapcode-violet" icon="robots">
          <Formik
            initialValues={{ robotsTxt }}
            onSubmit={(values, { setSubmitting }) => {
              !isReadOnly && this.handleRobotsTxtSubmit(values);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, errors }) => {
              return (
                <Form className="form-horizontal">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                      <div className="form-group">
                        <Field
                          as="textarea"
                          rows="10"
                          name="robotsTxt"
                          className="form-control form-control-sm"
                          placeholder="Insert your Robots.txt content here.."
                        />
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-12 text-right d-flex justify-content-between">
                      <div>
                        <button
                          type="button"
                          className="btn btn-outline btn-md"
                          onClick={() => this.props.toggle('appConstant')}
                        >
                          <i className="wb webconnect-times"></i> Cancel
                        </button>
                      </div>
                      <div>
                        <button type="reset" className="btn btn-default btn-md">
                          <span>
                            <i className={`wb ${drapcodeIcon('eraser')}`}></i>&nbsp;Clear
                          </span>
                        </button>
                        &nbsp;
                        {!(content && content.robotsTxt) ? (
                          <button
                            type="submit"
                            className="btn btn-theme-submit btn-md"
                            disabled={isSubmitting || addProjectRobotsTxtPending}
                            title="Save Robots.txt"
                          >
                            <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Save
                            <CustomLoader loading={addProjectRobotsTxtPending} />
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-theme-submit btn-md"
                            disabled={isSubmitting || addProjectRobotsTxtPending || isReadOnly}
                            title={isReadOnly ? 'Read-Only Mode' : 'Update Robots.txt'}
                          >
                            <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update
                            <CustomLoader loading={addProjectRobotsTxtPending} />
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </ParentContentCard>
        <ParentDocCard>
          <h5>
            <b>About Robots.txt</b>
          </h5>
          <p>{robotsTxt}</p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-settings/robots.txt/" />
        </ParentDocCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RobotsTxt);
